module.exports = __webpack_public_path__ + "static/media/yellow_circle.39652d56.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Buildings/Manage/Map/Marker/img/yellow_circle.png
// module id = 1131
// module chunks = 0